import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { UpdateAmountAndTermRequest } from '@core/model/update-amount-and-term-request';
import { LoanApplicationAdditionalInfo } from '@core/model/loanApplicationAdditionalInfo';

@Injectable({
  providedIn: 'root',
})
export class LoanApplicationService {
  apiUrl = environment.apiUrl;
  updateAmountAndTermUrl = `${this.apiUrl}loanapplication/loan-application/update/amount/term`;
  saveAdditionalInfoURL = `${this.apiUrl}loanapplication/loan-application/aditional-info`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public updateAmountAndTerm(updateAmountAndTermRequest: UpdateAmountAndTermRequest): Observable<boolean> {
    return this.http
      .post(this.updateAmountAndTermUrl, updateAmountAndTermRequest, {
        headers: this.headers,
      })
      .pipe(
        map((response: boolean) => {
          return response;
        })
      );
  }

  public saveAdditionalInfo(request: LoanApplicationAdditionalInfo): Observable<boolean> {
    return this.http.post<boolean>(this.saveAdditionalInfoURL, request, { headers: this.headers });
  }
}
